module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_305587.ca219456.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetAlTFF/FormatoSimplificado_305587.pdf
// module id = 815
// module chunks = 0